import React from 'react'
import Hero from './Hero/Hero'

const HomePage = () => {
  return (
    <div>
        <Hero/>
    </div>
  )
}

export default HomePage